<template>
  <div class="npb-voice-flash-call-overlay">
    <div class="npb-voice-flash-call-modal">
      <button type="button" class="npb-voice-flash-call-close-btn" @click="closeCallModal">&times;</button>
      <div v-if="isSMS" class="npb-voice-flash-call-image__sms with-modal"></div>
      <div v-else-if="isFlashCall" class="npb-voice-flash-call-image__flash with-modal"></div>
      <div v-else-if="isVoiceCall" class="npb-voice-flash-call-image__voice with-modal"></div>
      <div class="npb-voice-flash-call-content">
        <div v-if="isSMS">
          <div class="npb-voice-flash-call-content__title">
            <i18n val="second_step_modal_sms_info_title"></i18n>
          </div>
          <div class="npb-voice-flash-call-content__text">
            <i18n val="second_step_modal_sms_info_text"></i18n>
          </div>
          <div class="npb-voice-flash-call-button" @click.once="sendPhoneModalRequest">
            <button type="button" class="btn btn-block btn-sm npb-main-button">
              <i18n val="second_step_modal_sms_button_text"></i18n>
            </button>
          </div>
        </div>
        <div v-else-if="isFlashCall">
          <div class="npb-voice-flash-call-content__title">
            <i18n val="second_step_modal_flash_call_info_title"></i18n>
          </div>
          <div class="npb-voice-flash-call-content__text">
            <span><i18n val="second_step_modal_flash_call_info_text_example"></i18n> </span>
            <span class="npb-voice-flash-call_content__text-phone npb-nowrap">
              <span><i18n val="second_step_modal_flash_call_info_text_phone"></i18n></span> <span class="npb-voice-flash-call-content__text-circled">4359</span>
            </span>
          </div>
          <div class="npb-voice-flash-call-content__text">
            <i18n val="flash_call_info_text_extend"></i18n>
          </div>
          <div class="npb-voice-flash-call-button">
            <button type="button" class="btn btn-block btn-sm npb-main-button" @click.once="sendPhoneModalRequest">
              <i18n val="second_step_modal_flash_call_button_text"></i18n>
            </button>
          </div>
        </div>
        <div v-else-if="isVoiceCall">
          <div class="npb-voice-flash-call-content__title">
            <i18n val="second_step_modal_voice_call_info_title"></i18n>
          </div>
          <div class="npb-voice-flash-call-content__text">
            <i18n val="second_step_modal_voice_call_info_text"></i18n>
          </div>
          <div  class="npb-voice-flash-call-button" @click.once="sendPhoneModalRequest">
            <button type="button" class="btn btn-block btn-sm npb-main-button">
              <i18n val="second_step_modal_voice_call_button_text"></i18n>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import I18n from "./i18n.vue";

    export default {
      components: {I18n},
      props: {
        isSMS: Boolean,
        isFlashCall: Boolean,
        isVoiceCall: Boolean,
        closeCallModal: Function,
        sendPhoneModalRequest: Function,
      },
    }
</script>

<style scoped>
.npb-pincode-target {
    direction: ltr;
    display: inline-block;
}
</style>
